<template>
    <div style='width:90%;margin: auto;'>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show" v-if="swtich_tab=='login'">
                <el-form label-position="left" :rules="rules" style="margin-bottom: 10px;">
                    <el-form-item>
<!--                        <el-radio v-model="account_type" label="1">外國居民</el-radio>-->
                        <el-radio v-model="account_type" label="0">{{$t("form.tw_id_type")}}</el-radio>
                        <el-radio v-model="account_type" label="2">{{$t("form.mobile_type")}}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('form.tw_id')" v-if="account_type!=2" prop="user_id">
                        <el-input type="text"   :placeholder="$t('form.tw_id')" v-model="user_id" required></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.phone_code')" v-if="account_type==2"  prop="phone_code_val">
                        <el-select v-model="phone_code_val_Key" required filterable @change='set_phone_code' :placeholder="$t('main.select')">
                            <el-option v-for="(item,key) in phone_code" :value="key" :key="key" :label="item.name+'('+item.dial_code+')'" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('form.mobile')" v-if="account_type==2" prop="phone_num">
                        <el-input type="tel"   :placeholder="$t('form.mobile_p')" v-model="phone_num" required pattern="[0-9]{10}"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.pwd')" prop="user_pwd_login">
                        <el-input type="password"  :placeholder="$t('form.pwd')" v-model="user_pwd" required></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.lang')" prop="lang">
                        <el-select  v-model="lang" required @change='$i18n.locale=lang'>
                            <el-option v-for="(item,key) in lang_list" :value="key" :key="key"  :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" class="bt-color" @click="getToken" style="width: 100%;">{{$t("form.login")}}</el-button>
                </el-form>
                <a style="position: absolute;left: 5%;color:cornflowerblue;" @click="swtich_tab='reset'">{{$t("form.forget_pwd")}}</a>
                <a style="position: absolute;right: 5%;color:cornflowerblue;" @click="swtich_tab='register'">{{$t("form.register")}}</a>
            </div>
            <div v-if="swtich_tab=='reset'">
                <el-form label-position="left" :rules="rules" style="margin-bottom: 10px;">
                    <el-form-item>
<!--                        <el-radio v-model="account_type" label="1">外國居民</el-radio>-->
                        <el-radio v-model="account_type" label="0">{{$t("form.tw_id_type")}}</el-radio>
                        <el-radio v-model="account_type" label="2">{{$t("form.mobile_type")}}</el-radio>
                    </el-form-item>
                    <el-form-item  v-if="account_type!=2" :label="$t('form.tw_id')" prop="user_id">
                        <el-input type="text"  :placeholder="$t('form.tw_id')" v-model="user_id" required></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.phone_code')"  prop="phone_code_val">
                        <el-select v-model="phone_code_val_Key" required filterable @change='set_phone_code' :placeholder="$t('main.select')">
                            <el-option v-for="(item,key) in phone_code" :value="key" :key="key" :label="item.name+'('+item.dial_code+')'" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('form.mobile')" prop="phone_num">
                        <el-input type="tel"  :placeholder="$t('form.mobile_p')" v-model="phone_num" required></el-input>
                    </el-form-item>
                    <el-button type="primary" class="bt-color"  @click="reset_pawwsord" style="width: 100%;">{{$t("form.reset_pwd")}}</el-button>
                </el-form>
                <a @click="swtich_tab='login'" style="position: absolute;right: 5%;color:cornflowerblue;">{{$t("form.back_login")}}</a>
            </div>
            <div v-if="swtich_tab=='register'">
                <el-form label-position="left" :rules="rules" ref="registerForm" :model="data0" style="margin-bottom: 10px;">
                    <el-form-item>
<!--                        <el-radio v-model="account_type" label="1">外國居民</el-radio>-->
                        <el-radio v-model="account_type" label="0" active>{{$t("form.tw_id_type")}}</el-radio>
                        <el-radio v-model="account_type" label="2">{{$t("form.mobile_type")}}</el-radio>
                    </el-form-item>
                    <el-form-item :label="$t('form.name')"  prop="user_name">
                        <el-input type="text"  :placeholder="$t('form.name_p')" v-model="user_name" required></el-input>
                    </el-form-item>
                    <el-form-item  v-if="account_type!=2" :label="$t('form.tw_id')"  prop="user_id">
                        <el-input type="text"   :placeholder="$t('form.tw_id')" v-model="user_id" required></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.phone_code')"  prop="phone_code_val">
                        <el-select v-model="phone_code_val_Key" required filterable @change='set_phone_code' :placeholder="$t('main.select')">
                            <el-option v-for="(item,key) in phone_code" :value="key" :key="key" :label="item.name+'('+item.dial_code+')'" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('form.mobile')"  prop="phone_num">
                        <el-input type="tel"   :placeholder="$t('form.mobile_p')" v-model="phone_num" required pattern="[0-9]{10}"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.veritfy_code')"  prop="sms_verify_code">
                        <el-row style="display: inline-block;">
                        <el-col :span="14"><el-input type="text"  :placeholder="$t('form.veritfy_code_p')" v-model="sms_verify_code" required></el-input></el-col>
                        <el-col :span="10"><el-button class="bt-color" type="primary" :disabled="resend_time>0" @click="send_verify_code">{{$t('form.send_veritfy_code')}}{{resend_time>0?'('+resend_time+')':''}}</el-button></el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item :label="$t('form.lang')"  prop="lang">
                        <el-select  v-model="lang" required @change='$i18n.locale=lang'>
                            <el-option v-for="(item,key) in lang_list" :value="key" :key="key" :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('form.pwd')"  prop="user_pwd">
                        <el-input type="password"  :placeholder="$t('form.lang')" v-model="user_pwd" required pattern="^(?=^.{6,12}$)((?=.*[0-9])(?=.*[a-z|A-Z]))^.*$"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('form.pwd_again')"   prop="user_pwd_check">
                        <el-input type="password"  :placeholder="$t('form.pwd_again')" v-model="user_pwd_check" :pattern="user_pwd" required  :title="$t('form.pwd_def')"></el-input>
                    </el-form-item>
                    <el-form-item prop="agree">
                        <el-checkbox v-model="agree" required >
                            <label class="form-check-label" for="exampleCheck1">{{$t('form.i_agree')}}</label><a style='color:cornflowerblue' @click='showAgreedDig=true'>{{$t('form.private_role')}}</a>
                        </el-checkbox>
                    </el-form-item>
                    <el-button class="bt-color" type="primary" @click="checkUserId" style="width: 100%;">{{$t('form.to_register')}}</el-button>
                </el-form>
                <a @click="swtich_tab='login'" style="position: absolute;right: 5%;color:cornflowerblue;">{{$t('form.back_login')}}</a>
            </div>
        </div>
        <el-dialog
        :title="$t('main.popup_title')"
        :visible.sync="showAgreedDig"
        width="95%">
        <span v-html='$t("main.private_note")' style='text-align: left;'></span>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="showAgreedDig = false">取 消</el-button> -->
            <el-button type="primary" @click="showAgreedDig = false">{{$t("main.agree")}}</el-button>
        </span>
    </el-dialog>
    </div>
</template>
<style>
    .el-select{
        position: absolute;
        right: 0px;
    }
    .el-form-item.is-error .el-form-item__content .el-checkbox .el-checkbox__input .el-checkbox__inner{
        border-color: #F56C6C;
    }
    .bt-color{
        background-color:#003E5F;
        border-color:#003E5F;
    }
</style>
<script>
    import phone_code from './CountryCodes.json';
//    var deviceToken = ''
    import axios from 'axios'

    export default {
    name: 'LoginRegister',
        props:['partner', 'device_token', 'refresh_url', 'api_base_url'],
        data() {
            var validatePass = (rule, value, callback) => {
                if(rule.field=='user_pwd_login' && this.user_pwd===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else if(rule.field=='agree' && this.agree!=true){
                    return callback(new Error(this.$i18n.t("form.need_agree")));
                }else if(rule.field=='phone_code_val' && this.phone_code_val===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else if (this[rule.field] === '') {
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }
            }
            var validatePhone = (rule, value, callback) => {
                if(this.phone_num===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else{
                    var myRe = /[0-9]{10}/;
                    if(myRe.exec(this.phone_num)==null){
                        return callback(new Error(this.$i18n.t("form.error_mobile")));
                    }
                }
            }
            var validatePwd = (rule, value, callback) => {
                if(this.user_pwd===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else{
                    var myRe = /^(?=^.{6,12}$)((?=.*[0-9])(?=.*[a-z|A-Z]))^.*$/;
                    if(myRe.exec(this.user_pwd)==null){
                        return callback(new Error(this.$i18n.t("form.pwd_error")));
                    }
                }
            }
            var validatePwdChk = (rule, value, callback) => {
                if(this.user_pwd===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else{
                    if(this.user_pwd!=this.user_pwd_check){
                        return callback(new Error(this.$i18n.t("form.pwd_def_msg")));
                    }
                }
            }
            var validateVcode = (rule, value, callback) => {
                if(this.sms_verify_code===''){
                    return callback(new Error(this.$i18n.t("form.need_ans")));
                }else{
                    if(this.sms_verify_code.length!=4){
                        return callback(new Error(this.$i18n.t("form.pwd_def_msg")));
                    }
                }
            }
            return {
                phone_code: phone_code,
                user_id: '',
                user_name:'',
                phone_num: '',
                user_pwd: '',
                user_pwd_check:'',
                phone_code_val: '+886',
                phone_code_val_Key:235,
                account_type: '0',
                lang:this.$i18n.locale,
                lang_list: {'zh_CN': '简体中文', 'zh_TW': '繁體中文', 'en':'English'},
                agree: '',
                family_account:'',
                showAgreedDig:false,
                swtich_tab:'login',
                sms_verify_code:'',
                resend_time:0,
                data0:{},
                rules: {
                    user_id:[{ validator: validatePass, trigger: 'change' }],
                    phone_code_val:[{validator: validatePass, trigger: 'change'}],
                    user_pwd_login:[{validator: validatePass, trigger: 'change'}],
                    user_name:[{ validator: validatePass, trigger: 'change' }],
                    phone_num: [ {validator: validatePhone, trigger: 'change'} ],
                    lang:[{validator: validatePass,trigger: 'change'}],
                    user_name:[{validator: validatePass,trigger: 'change'}],
                    user_pwd:[{validator: validatePwd, trigger: 'change'}],
                    user_pwd_check:[{validator: validatePwdChk, trigger: 'change'}],
                    sms_verify_code:[{validator: validateVcode, trigger: 'change'}],
                    agree:[{validator: validatePass, trigger: 'change'}],
                }
            }

        },
        mounted() {

        },
        computed:{
        },
        watch: {
        },
        methods: {
            getToken: function (e) {
                const _this = this;
                if (this.account_type == 2) {
                    this.user_id = this.phone_code_val + this.phone_num
                }
                if (this.user_id == '' || this.user_pwd == '') {
                    alert(this.$i18n.t("form.from_check"))
                    return;
                }
                let account = this.family_account != '' ? this.family_account : this.user_id
                axios.post(this.api_base_url + '/user/login', {}, {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    data: {
                        id: account,
                        pwd: this.user_pwd,
                        app:  0,
                        ver: 0,
                        is_doctor: 0,
                        voipToken: this.deviceToken,
                        apnsToken: this.deviceToken,
                        phoneType: 3,
                        partner: this.partner,
                        appLang: this.lang,
                        account_type: this.account_type
                    },
                    data: {
                        id: account,
                        pwd: this.user_pwd,
                        app:  0,
                        ver: 0,
                        is_doctor: 0,
                        voipToken: sessionStorage.getItem('deviceTokenKey'),
                        apnsToken: sessionStorage.getItem('deviceTokenKey'),
                        phoneType: 3,
                        partner: this.partner,
                        appLang: this.lang,
                        account_type: this.account_type
                    },
                })
                    //.then(response => (tokenId = response.data.token))
                .then(function (response) {
                    // let def_pwd = response.data.def_pwd != undefined ? response.data.def_pwd : false;
                    if (response.data.status == 'OK' || response.data.status == 'unfinsh_signup' || response.data.status == 'unfinsh_verify' || response.data.status == 'phone_check') {
                        sessionStorage.setItem("tokenId", response.data.token)
                        window.open(_this.refresh_url + '?platform=web'+(_this.partner!=''?'&partner_id='+_this.partner:'')+(_this.partner!=''?'&partner='+_this.partner:'')+'&tokenId=' + response.data.token + '&deviceToken=' + _this.device_token + '&lang=' + _this.lang)
                        _this.$eventBus.$emit('login_done',true);
                    } else {
                        switch (response.data.msg){
                            case 'notFound':
                                alert(_this.$i18n.t("form.error_account_alert"));
                                break;
                            case 'error_pwd':
                                alert(_this.$i18n.t("form.error_pwd_alert"));
                                break;
                            case 'login_many_time':
                                alert(_this.$i18n.t("form.try_too_many_time"));
                                break;
                            default:
                                alert(_this.$i18n.t("form.error"));
                                break;
                        }
                    }
                    return;
                })
                e.preventDefault();
            },
            insertUserData: function () {
                // let app = this.$f7;
                let _this = this;
                this.$refs['registerForm'].validate((valid) => {
                    console.log(valid)
                });
                if(_this.phone_num=='' || _this.user_pwd=='' || _this.phone_code_val=='' || _this.agree!=true || _this.sms_verify_code=='' || _this.account_type=='' || _this.user_name==''){
                    alert(this.$i18n.t("form.from_check"));
                    return;
                }
                axios.post(this.api_base_url + '/user/insertUserData', {}, {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    data: {
                        user_id: this.account_type == 2?(_this.phone_code_val.replace('+', '')) + _this.phone_num:_this.user_id,
                        phone_num: _this.phone_num,
                        user_pwd: _this.user_pwd,
                        phone_code_val: _this.phone_code_val,
                        agree: _this.agree,
                        sms_verify_code: _this.sms_verify_code,
                        panter_id:this.partner,
                        app: 0,
                        account_type:this.account_type,
                        auto_login:1,
                        user_name:this.user_name
                    }
                })
                .then(function (response) {
                    let status = response.data.status;
                    if (status == 'ok' || status == 'OK' || status == 'unfinsh_signup' || status == 'unfinsh_verify' || status == 'phone_check'){
                        alert(_this.$i18n.t("form.reg_sucess"))
                        setTimeout(function(){
                            sessionStorage.setItem("tokenId", response.data.token)
                            _this.$eventBus.$emit('login_done',true);
                            window.open(_this.refresh_url + '?platform=web'+(_this.partner!=''?'&partner_id='+_this.partner:'')+'&tokenId=' + response.data.token + '&deviceToken=' + _this.device_token + '&lang=' + _this.lang)
                        },1)
                    }else{
                        alert(_this.$i18n.t("form.from_check"));
                    }
                })
            },
            checkUserId: function (e) {
                // let $$ = this.Dom7;
                let _this = this;
                // let app = this.$f7;
                _this.user_id = this.account_type == 2?(_this.phone_code_val.replace('+', '')) + _this.phone_num:_this.user_id

                if (this.account_type != 2 && _this.checkID(_this.user_id) == false){
                    alert(this.$i18n.t("form.error_id"));
                    return;
                }
                axios.post(this.api_base_url + '/user/checkUserId', {}, {
                    headers: {
                    "Content-Type": "application/json;charset=utf-8"
                },
                data: {
                    user_id: _this.user_id,
                        phone: this.phone_num,
                        account_type:this.account_type
                    }
                })
                .then(function (response) {
                    switch (response.data.msg){
                        case 'Can use':
                            _this.insertUserData();
                            break;
                        case 'ID is used':
                            alert(_this.$i18n.t("form.registered"));
                            break;
                        case 'ID is Disabled':
                            alert(_this.$i18n.t("form.id_disable"));
                            break;
                        case 'phone is used':
                            alert(_this.$i18n.t("form.phone_registered"));
                            break;
                        default:
                            alert(_this.$i18n.t("form.error"));
                            break;
                    }
                })
                e.preventDefault();
            },

            checkID: function (id) {
                //建立字母分數陣列(A~Z)
                var city = new Array(
                    1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11,
                    20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3, 12, 30
                )
                id = id.toUpperCase();
                // 使用「正規表達式」檢驗格式
                if (!id.match(/^[A-Z]\d{9}$/) && !id.match(/^[A-Z][A-D]\d{8}$/)) {
                    return false;
                } else {
                    var total = 0;
                    if (id.match(/^[A-Z]\d{9}$/)) { //身分證字號
                        //將字串分割為陣列(IE必需這麼做才不會出錯)
                        id = id.split('');
                        //計算總分
                        total = city[id[0].charCodeAt(0) - 65];
                        for (var i = 1; i <= 8; i++) {
                            total += eval(id[i]) * (9 - i);
                        }
                    } else { // 外來人口統一證號
                        //將字串分割為陣列(IE必需這麼做才不會出錯)
                        id = id.split('');
                        //計算總分
                        total = city[id[0].charCodeAt(0) - 65];
                        // 外來人口的第2碼為英文A-D(10~13)，這裡把他轉為區碼並取個位數，之後就可以像一般身分證的計算方式一樣了。
                        id[1] = id[1].charCodeAt(0) - 65;
                        for (let i = 1; i <= 8; i++) {
                            total += eval(id[i]) * (9 - i);
                        }
                        //補上檢查碼(最後一碼)
                        total += eval(id[9]);
                        //檢查比對碼(餘數應為0);
                        return ((total % 10 == 0));
                    }
                }
            },
            reset_pawwsord(e){
                let _this = this;
                axios.post(this.api_base_url + '/user/resetPassword', {}, {
                    headers: {
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    data: {
                        id: _this.account_type == 2?_this.phone_code_val + _this.phone_num:_this.user_id,
                            phone_code: _this.phone_code_val,
                            phone:  _this.phone_num,
                            type: 'p',
                            account_type:_this.account_type
                    }
                })
                .then(function (response) {
                    let status = response.data.status;
                    // let msg = '';
                    if (status == 'ok'){
                        alert('sucess')
                    } else{
                        alert('error')
                    }
                })
                e.preventDefault();
            },
            send_verify_code: function () {
                let _this = this;
                if (localStorage.getItem("tokenId") != 'undefined' && localStorage.getItem("tokenId") != undefined) {

                }else if(_this.phone_code_val=='' || _this.phone_num==''){
                    this.$refs['registerForm'].validateField('phone_num');
                    this.$refs['registerForm'].validateField('phone_code_val');
                } else {
                    if(_this.resend_time<=0){
                        _this.resend_time=60;
                    }
                    _this.reciprocal();
                    axios.post(this.api_base_url + '/user/sendVerify', {}, {
                        headers: {
                            "Content-Type": "application/json;charset=utf-8"
                        },
                        data: {
                            phone: _this.phone_code_val + _this.phone_num,
                            app: 0,
                        }
                    })
                    .then(function (response) {
                        if(response.status!=''){
                            alert(_this.$i18n.t("form.sms_send"));
                        }
                    })
                }
            },
            reciprocal(){
                let _this=this;
                var interval = setInterval(function(){
                    if(_this.resend_time>0){
                        _this.resend_time--;
                    }else{
                        clearInterval(interval);
                    }
                }, 1000);
            },
            set_phone_code(e){
                this.phone_code_val=phone_code[e].dial_code
            }
        }
    }

</script>